// extracted by mini-css-extract-plugin
module.exports = {"expandIconSvg":"CustomIcon_expandIconSvg__3EVDJ","expandIcon":"CustomIcon_expandIcon__1TdYR","open":"CustomIcon_open__1glj8","closed":"CustomIcon_closed__ngDsd"};